export const palette = {
  exampleColor: '#F0F0F0',
  silver: '#D3D3D3',
  basicGray: '#D0D0D0',
  almostWhite: '#ececec',
  sublimeGray: '#a5a5a5',
  darkerGray: '#2B4141',
  someBlue: '#0076af',
  primaryColor: '#022759',
  secondaryColor: '#3DBC94',
  secondaryColorShy: '#4EC29D',
  terciaryColor: '#08AEEA',
  secondaryButtonGray: 'rgb(233,233,233)',
  terciaryColorShy: '#34BCED',
  finautaOrange: '#FE4A49',
  finautaOldOrange: '#FF9D39',
  secondaryActiveText: '#009287',
  secondaryActiveBg: '#bfffeb',
  sweetGray: '#f4f5f7',
  interestGray: '#e1e1e1',
  sweetPurple: '#756AE7',
  white: '#FFF',
  disabled: '#a5a5a5',
  titlesColors: '#1d2d35',
  textColor: '#2B4141',
  preClick: '#304E77',
  okGreen: '#22E00B',
  marron: '#6B0504',
  morado: '#564787',
  azulClaro: '#3AAFB9',
  azulFuerte: '#03254E',
  primaryOpacity: alfa => `rgba(2, 39, 89,${alfa})`,
};

export const resultPalette = [
  ['#00aba9', '#ff0097', '#a200ff', '#1ba1e2', '#f09609'],
  ['#ffbe4f', '#6bd2db', '#0ea7b5', '#0c457d', '#e8702a'],
];

export const breakpoints = {
  exception: '@media screen and (min-width: 360px)',
  mobileLandscape: '@media screen and (min-width: 440px)',
  tablet: '@media screen and (min-width: 570px)',
  tabletLandscape: '@media screen and (min-width: 770px)',
  desktop: '@media screen and (min-width: 1024px)',
  desktop2: '@media screen and (min-width: 1109px)',
  desktop3: '@media screen and (min-width: 1194px)',
  larger: '@media screen and (min-width: 1280px)',
};

export const typography = {
  museo: 'Poppins',
  museoSans: "'Poppins', sans-serif",
};

export const fillSpace = `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export const flexCenter = `
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const flexColumn = `
  display: flex;
  flex-direction: column;
`;

export const flexRow = `
  display: flex;
  flex-direction: row;
`;

export const flexSpaceBetween = `
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  align-items: center;
`;

export const flexSpaceAround = `
  display: flex;
  justify-content: space-around;
  align-content: space-around;
  align-items: center;
`;
